export default "__VITE_ASSET__ba9bf77e__"